import React, { useContext } from 'react';
import { MenuItem, MenuItemProps } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function CommonMenuItem(props: MenuItemProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <MenuItem
      {...props}
      sx={{ p: sp.s30, minWidth: 240, ...props.sx }}
    ></MenuItem>
  );
}
